import { ZpDataService } from './../services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { Subscription } from 'rxjs';
import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()

export class DelegateHelpers {
    myUser: IUser; //TODO - I don't think we need to subscribe here
    constructor(private zenData: ZpDataService,
        private userInfo: UserInfoService,
        private router: Router) {
        // this.userInfo.getMessage().subscribe(user => {
        //     this.myUser = JSON.parse(user);
        //   });
    }
    // public  async delegateLogIntoUser(delegate,clientId){

    //     let client = await this.zenData.getItem(clientId,"users");
    //     client["delegate"] = delegate;
    //     this.userInfo.changeMessage(JSON.stringify(client));
    // }

    public async delegateChooseSharedPlan(delegate, myUser) {
        console.log('delegate - ', delegate)
        console.log('myUser - ', myUser)
        myUser["sharedPlanUserId"] = delegate["clientId"];
        myUser["delegate"] = delegate;
        await this.userInfo.changeMessage(JSON.stringify(myUser));
    }

    public async seeSharedPlan(section, chosenPlan, myUser, professional?) {
      sessionStorage.setItem('chosenSharedPlan', JSON.stringify(chosenPlan)); //fix for plan with no jointOwners yet.

      switch (section) {
            case "dashboard":
                //if(chosenPlan[""])
                //this.delegateHelpers.delegateLogIntoUser(chosenPlan, chosenPlan["clientId"])
                await this.delegateChooseSharedPlan(chosenPlan,myUser);
                this.router.navigate(['/my-dashboard']);
                break;
            case "assets":
                console.log('This section is an asset')
                if (chosenPlan["assetsPermission"] != "now" &&
                    chosenPlan["assetsPermission"] != "contributor" && !professional) {
                    this.router.navigate(['/request-access']);
                    break;
                }
                //await this.delegateHelpers.delegateLogIntoUser(chosenPlan, chosenPlan["clientId"])
                await this.delegateChooseSharedPlan(chosenPlan, myUser);
                this.router.navigate(['/my-assets']);
                break;
            case "debts":
                if (chosenPlan["debtsPermission"] != "now" &&
                    chosenPlan["debtsPermission"] != "contributor") {
                    this.router.navigate(['/request-access']);
                    break;
                }
                //this.delegateHelpers.delegateLogIntoUser(chosenPlan, chosenPlan["clientId"])
                await this.delegateChooseSharedPlan(chosenPlan,myUser);
                this.router.navigate(['/my-debts']);
                break;
            case "dailyLife":
                if (chosenPlan["dailyLifePermission"] != "now" &&
                    chosenPlan["dailyLifePermission"] != "contributor") {
                    this.router.navigate(['/request-access']);
                    break;
                }
                //this.delegateHelpers.delegateLogIntoUser(chosenPlan, chosenPlan["clientId"])
                await this.delegateChooseSharedPlan(chosenPlan, myUser);
                this.router.navigate(['/my-daily-life']);
                break;
            case "digitalLife":
                if (chosenPlan["digitalLifePermission"] != "now" &&
                    chosenPlan["digitalLifePermission"] != "contributor") {
                    this.router.navigate(['/request-access']);
                    break;
                }
                //this.delegateHelpers.delegateLogIntoUser(chosenPlan, chosenPlan["clientId"])
                await this.delegateChooseSharedPlan(chosenPlan, myUser);
                this.router.navigate(['/my-digital-life']);
                break;
            case "wishes":
                if (chosenPlan["wishesPermission"] != "now" &&
                    chosenPlan["wishesPermission"] != "contributor") {
                    this.router.navigate(['/request-access']);
                    break;
                }
                //this.delegateHelpers.delegateLogIntoUser(chosenPlan, chosenPlan["clientId"])
                await this.delegateChooseSharedPlan(chosenPlan, myUser);
                this.router.navigate(['/my-wishes']);
                break;
            case "summaries":
                if ((chosenPlan["assetsPermission"] != "now" &&
                    chosenPlan["assetsPermission"] != "contributor") && (chosenPlan["debtsPermission"] != "now" &&
                    chosenPlan["debtsPermission"] != "contributor") && (chosenPlan["dailyLifePermission"] != "now" &&
                    chosenPlan["dailyLifePermission"] != "contributor") && (chosenPlan["digitalLifePermission"] != "now" &&
                    chosenPlan["digitalLifePermission"] != "contributor")) {
                    this.router.navigate(['/request-access']);
                    break
                }
                await this.delegateChooseSharedPlan(chosenPlan, myUser);
                this.router.navigate(['/financial-summaries']);
                break;

        }
    }
}



